import { css, cx } from "@emotion/css";
import { memo, ReactNode } from "react";

import { useTheme } from "@/modules/theme/hooks/useTheme";
import { Theme } from "@/modules/theme/utils/createTheme";

import { NavMenu } from "./components/NavMenu/NavMenu";

export interface AuthenticatedLayoutProps {
  children?: ReactNode;
  containerClassName?: string;
}

export const AuthenticatedLayout = memo(
  ({ children, containerClassName }: AuthenticatedLayoutProps) => {
    const classes = createStyles(useTheme());

    return (
      <div className={classes.wrapper}>
        <div className={classes.content}>
          <main className={cx(classes.main, containerClassName)}>
            {children}
          </main>
          <NavMenu />
        </div>
      </div>
    );
  }
);

function createStyles({ spacing, palette }: Theme) {
  return {
    wrapper: css({
      display: "flex",
      flexDirection: "column",
      minHeight: "100%",
    }),
    content: css({
      display: "flex",
      flex: 1,
    }),
    main: css({
      padding: spacing([3, 3, 12]),
      flex: 1,
      backgroundColor: palette.default.background,
    }),
  };
}
